import { render, staticRenderFns } from "./previewCustomForm.vue?vue&type=template&id=276249a2&"
import script from "./previewCustomForm.vue?vue&type=script&lang=js&"
export * from "./previewCustomForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VContainer,VForm,VRow,VSheet})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('276249a2')) {
      api.createRecord('276249a2', component.options)
    } else {
      api.reload('276249a2', component.options)
    }
    module.hot.accept("./previewCustomForm.vue?vue&type=template&id=276249a2&", function () {
      api.rerender('276249a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/CustomForm/CustomForm/previewCustomForm.vue"
export default component.exports